import type { ReactNode } from "react";

interface PanelProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}

export function Panel({
  title,
  subtitle,
  actions,
  children,
  className = "",
  bodyClassName = "",
}: PanelProps) {
  return (
    <section className={`rounded-md border border-line bg-panel ${className}`}>
      <header className="flex items-start gap-3 px-5 py-4 border-b border-line-2">
        <div className="flex-1 min-w-0">
          <h3 className="font-display font-semibold text-base text-ink">{title}</h3>
          {subtitle && <div className="text-xs text-ink-2 mt-0.5">{subtitle}</div>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </header>
      <div className={bodyClassName || "p-5"}>{children}</div>
    </section>
  );
}
